/** Date formatting shared by the signing list and its detail panel. */

function localeOf(language: string): string {
  return language === "et" ? "et-EE" : "en-GB";
}

/** `13.07.2026, 09:14` — used where the exact signing moment matters. */
export function formatSigningDateTime(iso: string, language: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString(localeOf(language), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
